module.exports = __webpack_public_path__ + "img/cart.3d3fae5.png";